import { useState } from 'react';

export const useToggle = (initial = false) => {
  const [visible, setVisible] = useState(initial);
  const onToggle = () => {
    setVisible((current) => !current);
  };

  return { visible, onToggle };
};
